import React from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import { Image, Transformation, CloudinaryContext } from 'cloudinary-react';
import cloudinary from 'cloudinary-core';

import ContactModel from '../components/ContactModel';
import fonts from './../assets/fonts/circular-std-book/style.scss';


// SVG
import instagramIcon from './../assets/icon/instagram.svg';
import facebookIcon from './../assets/icon/facebook.svg';
import youtubeIcon from './../assets/icon/youtube.svg';
import gooseLogo from './../assets/icon/goose-logo.svg';

const cloudinaryCore = new cloudinary.Cloudinary({ cloud_name: 'wearegoosebclandingpage', secure: true });

const IconInsta = (
  <svg>
    <use xlinkHref={`#${instagramIcon.id}`} />
  </svg>
);
const IconFacebook = (
  <svg>
    <use xlinkHref={`#${facebookIcon.id}`} />
  </svg>
);
const IconYoutube = (
  <svg>
    <use xlinkHref={`#${youtubeIcon.id}`} />
  </svg>
);

const GooseLogo = (
  <svg>
    <use xlinkHref={`#${gooseLogo.id}`} />
  </svg>
);

class IndexRoute extends React.Component {
  state = { contactModelActive: false };

  handleContactModelClick = () => {
    this.setState({ contactModelActive: !this.state.contactModelActive });
  };

  createBackgroundImage = (publicId) => {
    const quality = 80;
    const secure = true;
    const t = new cloudinary.Transformation();
    t.crop('scale').dpr('auto').quality(quality);
    return cloudinaryCore.url(publicId, t);
  }


  render() {
    const items = [];

    const {
      title,
      subtitle,
      contactNumber,
      keywords,
      socialLinks
    } = this.props.data.site.siteMetadata;


    return (
      <div>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={subtitle} />
          <meta name="keywords" content={keywords} />

        </Helmet>
        <tagManagerHead />
        <tagManagerBody />
        <CloudinaryContext cloudName="wearegoosebclandingpage" fetchFormat="auto" secure="true" width="auto" quality="auto" dpr="auto">
          <header className="c-header l-header">
            <div className="c-header__logo o-logo">
              {GooseLogo}
            </div>
            <div className="c-header__nav">
              <Link onClick={this.handleContactModelClick} className="u-h6" to="/">Get in touch </Link>

              {/* <ul>
                <li><Link className="u-h6" to="/">Get in touch </Link></li>
                <li><Link className="u-h6" to="/">0211545302</Link></li>
              </ul> */}

            </div>
          </header>
          <div className="c-hero l-hero">
            <section className="c-heroContent l-heroContent">
              <div className="c-heroContent__col--1 l-heroContent__col--1">
                <div className="c-heroContent__row--1 l-heroContent__row--1">
                  <div className="testwrap">
                    <strong>BigCommerce Web Designers</strong>
                  </div>
                  <div className="c-heroContent__mobHeader">
                    <span className="c-hero-title u-hero">Trusted<br /> BigCommerce<br />Experts</span>
                    <Image alt="BigCommerce New Zealand" className="o-bcIcon" publicId="bc-logo-icon-dark.png" />
                  </div>
                </div>
                <div className="c-heroContent__row--2 l-heroContent__row--2">
                  <div className="c-heroContent__tagLine">
                    <h2 className="u-h4">We’re eCommerce specialists <br />focusing  solely on eCommerce <br />marketing &amp; development.</h2>
                  </div>
                  <div className="c-heroContent__scroll">
                    <div className="u-h5">Scroll</div>
                  </div>
                </div>
              </div>
              <div className="l-heroContent__col--2">
                <h1 className="c-hero-title u-hero">Trusted<br /> BigCommerce<br />Experts</h1>
              </div>
              <div style={{ backgroundImage: `url(${this.createBackgroundImage('herobg-kev')})` }} className="c-heroBg" />
            </section>
          </div>
          <section className="c-homeIntro l-homeIntro">
            <div className="vc-bg-lines dark"><div /><div /><div /><div /><div /><div /><div /></div>
            <div className="l-homeIntro__spacing">
              <h2 className="c-homeIntro__heading">
                <span className="c-homeIntro__heading__splitText u-hero">Every Maverick</span>
                <span className="c-homeIntro__heading__splitText u-hero">Needs a Goose.</span>
              </h2>
              <p className="c-homeIntro__intro u-impactIntro">Your BigCommerce Wingman. Proactive and reliable in nature. We have your back.
              As trusted BigCommerce experts in New Zealand, we work with ambitious merchants helping them sell more. Without breaking a sweat, replatform and begin future proofing your business.
              Let's accelerate your orders and <strong>goose</strong> the metrics that matter. <br /><span className="o-tgQuote">"It's time to buzz the tower." - Maverick</span>
              </p>
            </div>
            <div className="c-homeIntro__image l-homeIntro__image u-container u-container--m">
              <div className="l-homeIntro__image__wrap">
                {/* <img alt="BigCommerce Web Developer" src={homeIntroImage} /> */}
                <Image alt="BigCommerce Marketing Expert" publicId="sanya-bigcommerce-expert" />

                <div className="o-socialIcons ">
                  <a className="o-socialIcons__icon o-socialIcons__icon--inverse" href="https://www.instagram.com/wearegoose.co.nz/">{IconInsta} <span>Follow Us</span></a>
                </div>
                <div className="c-homeIntro__image__hashtag u-large">
                  <a href={socialLinks.instagram}>#thegaggle</a>
                </div>
              </div>
            </div>
          </section>
          <section className="c-homeServices l-homeServices">
            <div className="vc-bg-lines dark"><div /><div /><div /><div /><div /><div /><div /></div>
            <div className="l-homeServices__spacing">
              <div className="u-container u-container--heading">
                <h2 className="c-homeServices__heading l-homeServices__heading">
                      Right Place. Right Time. We Can Help.
                </h2>
                <p className="c-homeServices__intro l-homeServices__intro u-intro">We are hyper-focused on delivering these services and delivering them well.
                </p><br />
                <span className="o-tgQuote">"It takes a lot more than just fancy flying." - Charlie</span>
                <Image alt="BigCommerce Auckland" className="o-bcIcon" publicId="bc-logo-icon-dark.png" secure="true" width="auto" quality="auto" dpr="auto" />
              </div>
              <div className="c-homeServices__grid l-homeServices__grid u-container u-container--s">
                <div className="c-homeServices__service">
                  <h3 className="c-homeServices__service__serviceHeader u-h4">BigCommerce Design &amp; Development</h3>
                  <p>Most teams forget to ask enough questions. We start by listening, asking and listening some more. That makes a big difference. We’ve assembled a team of certified BigCommerce designers and developers ready to turn our learning into reality.</p>
                </div>
                <div className="c-homeServices__service">
                  <h3 className="c-homeServices__service__serviceHeader u-h4">Replatforming &amp; Data Migration</h3>
                  <p>First out of the gate selling online? A proprietary platform might have seemed a good idea at the time. Let us guess, that platform is now holding you back? You're not alone. We can move you to BigCommerce quickly, migrating your entire product catalogue and customer database. Want to update your category structure at the same time? No problem, we'll handle the SEO for you too.</p>
                </div>
                <div className="c-homeServices__service">
                  <h3 className="c-homeServices__service__serviceHeader u-h4">Ecommerce Marketing</h3>
                  <p>Google Search Ads, Google Display Ads, Google Video Ads, Google Shopping, Bing, Facebook/Instagram Ads and Email Marketing. Most Marketing Companies adopt a shotgun approach when it comes to marketing. Set and forget, with little to no analysis. That’s not just a shame, it’s a major missed opportunity. We know what needs to be done to maximise the return on your marketing investment. </p>
                </div>
                <div className="c-homeServices__service">
                  <h3 className="c-homeServices__service__serviceHeader u-h4">Support &amp; Maintenance</h3>
                  <p>We get you. You're a busy merchant, packing and shipping orders, dealing with customers, answering the phone. Let Goose take care of the online stuff. We are your wingman after all. We'll keep your store ticking over nicely, suggest improvements and keep you up to date with the latest techniques and cutting-edge conversion tactics. </p>
                </div>
                <div className="c-homeServices__service">
                  <div className="c-cutomerQuote">
                    <div className="c-cutomerQuote__image">
                      <Image alt="BigCommerce Certified Partner" publicId="stamps" />
                    </div>
                    <div className="c-cutomerQuote__quote">
                          "Our eCommerce website was sitting on a legacy platform.  Goose did a complete overhaul of our website, making it easier to use for our customers (both new and old); they also successfully integrated the site with our Oracle ERP. All of this was done with a very tight timeline where Goose demonstrated their agility time and again (not to mention their professionalism and patience with us). We’ve already noticed an uptick in growth online and have had a lot of positive feedback from our customers."
                    </div>
                    <div className="c-cutomerQuote__author">
                          -- By Kelly at NZ Post Collectables / <a href="https://collectables.nzpost.co.nz/">collectables.nzpost.co.nz</a>
                    </div>
                  </div>
                </div>
                <div className="c-homeServices__service">
                  <div className="c-cutomerQuote">
                    <div className="c-cutomerQuote__image">
                      <Image alt="BigCommerce Developer Partner" publicId="flowers" />
                    </div>
                    <div className="c-cutomerQuote__quote">
                          "We have struggled over the years to find the hand holding we required to grow our online business and to keep up with all the changes and opportunities online retailing offers. We have spent a lot of money over the years that has basically been very wasteful, also delaying our growth. We really love the fast efficient service we get from Goose for both development projects and for our day to day marketing. They are the perfect fit for us."
                    </div>
                    <div className="c-cutomerQuote__author">
                          -- By Kerry at Wild Poppies / <a href="https://www.wildpoppies.co.nz/">wildpoppies.co.nz</a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="c-bigCommerceBenefits c-bigCommerceBenefits--active">
                <div className="u-container u-container--m">
                  <div className="l-bigCommerceBenefits__badge">
                    <Image alt="Certified BigCommerce Partner" publicId="bc-badge" />
                  </div>
                  <div className="c-bigCommerceBenefits__heading l-bigCommerceBenefits__heading">
                    <h3 className="l-bigCommerceBenefits__heading__header u-h1">We Sense a Replatform Coming?</h3>
                    <p className="u-intro">Time to focus, roll up your sleeves, and make some difficult decisions <br />...don't worry though, BigCommerce makes that decision easy. <br />Here's how.</p> <br />
                    <p>"Let's turn and burn!" - Nick, in the air</p>
                  </div>
                  <div className="c-bigCommerceBenefits__benefits l-bigCommerceBenefits__benefits">
                    {/* <div className="c-bigCommerceBenefits__benefits__benefit l-bigCommerceBenefits__benefits__benefit">
                      <h4 className="o-benefit__header u-hero">Data Migration</h4>
                      <p>One of the more difficult challenges of running your own eCommerce website is dealing with speed – as in how quickly your website loads. That’s because speed matters.</p>
                    </div> */}
                    <div className="c-bigCommerceBenefits__benefits__benefit l-bigCommerceBenefits__benefits__benefit">
                      <h4 className="o-benefit__header u-hero">Modern Design</h4>
                      <p>BigCommerce's revolutionary design platform gives you the freedom to create stores that engage shoppers and make more sales. You can choose from a wide selection of pre-built responsive e-commerce templates or completely build your own to fit your specific needs. Imagination is the only barrier.</p>
                    </div>
                    <div className="c-bigCommerceBenefits__benefits__benefit l-bigCommerceBenefits__benefits__benefit">
                      <h4 className="o-benefit__header u-hero">Speed &amp; Security</h4>
                      <p>One of the challenges facing merchants is making sure your ecommerce website loads quickly. Speed matters. BigCommerce is setup for unparalleled performance. BigCommerce merchants benefit from industry-leading performance, stability and security, including an average uptime of more than 99.99%. Sites will load fast and maximise conversion. BigCommerce also takes care of security for you with Level 1 PCI compliance.</p>
                    </div>
                    <div className="c-bigCommerceBenefits__benefits__benefit l-bigCommerceBenefits__benefits__benefit">
                      <h4 className="o-benefit__header u-hero">Built-in Features</h4>
                      <p>We call BigCommerce an all-in-one platform. Right out of the box, you get a heap of advanced features to help scale your orders. From faceted search to advanced shipping and payment options, eBay and Amazon connectors, optimised checkout and abandoned cart emails. The list goes on.</p>
                    </div>
                    <div className="c-bigCommerceBenefits__benefits__benefit l-bigCommerceBenefits__benefits__benefit">
                      <h4 className="o-benefit__header u-hero">Marketing Focus</h4>
                      <p>BigCommerce takes away the headache of security and troublesome updates letting you concentrate on marketing your store.  Make use of BigCommerce's Channel Manager to simplify selling on multiple channels. Drive traffic to the store with best in class SEO baked in.</p>
                    </div>
                    <div className="c-bigCommerceBenefits__benefits__benefit l-bigCommerceBenefits__benefits__benefit">
                      <h4 className="o-benefit__header u-hero">Ease of Use</h4>
                      <p>
                      BigCommerce is easy to use. The backend is simple and intuitive. You will be packing and shipping orders in no time. Need additional functionality? BigCommerce provides 1-click app installations direct from the backend. Need to know the health of your online store? Make use of the advanced reporting BC offers.
                      </p>
                    </div>
                    <div className="c-bigCommerceBenefits__benefits__benefit l-bigCommerceBenefits__benefits__benefit">
                      <h4 className="o-benefit__header u-hero">Integrate Anywhere</h4>
                      <p>The best selection of ecommerce business apps and integrations BigCommerce's marketplace has an industry-leading selection of third-party apps and integrations, all carefully curated to make sure we only feature the best solutions. You can seamlessly connect your store to the software you need to sell effectively.</p>
                    </div>
                    {/* <div className="c-bigCommerceBenefits__benefits__benefit">
                      <div className="c-cutomerQuote">
                        <div className="c-cutomerQuote__image">
                          <img alt="BigCommerce Certified Partner" src={rcplane} />
                        </div>
                        <div className="c-cutomerQuote__quote">
                          "I was stuck with a proprietary eCommerce platform. Goose migrated my entire 15k+ product catalogue &amp; customers. They rapidly got my BigCommerce store live, with a seemless transition"
                        </div>
                        <div className="c-cutomerQuote__author">
                          -- By Daryl at RC Hobbies / <a href="https//www.rchobbies.co.nz">rchobbies.co.nz</a>
                        </div>
                      </div>
                    </div>
                    <div className="c-bigCommerceBenefits__benefits__benefit">
                      <div className="c-cutomerQuote">
                        <div className="c-cutomerQuote__image">
                          <img alt="BigCommerce Certified Partner" src={paint} />
                        </div>
                        <div className="c-cutomerQuote__quote">
                          "
                          I got in touch with Goose because I liked the name. I have been using their services for several months now, &amp; growth has been continuous, steady &amp; measurable. Their key focus is growing together, investing their time in understanding me, my business &amp; my market."
                        </div>
                        <div className="c-cutomerQuote__author">
                          -- By Matt at Millin / <a href="https://www.millin.co.nz/">millin.co.nz</a>
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <div className="c-bigCommerceBenefits__freetrial">
                    <div className="c-freeTrialBox l-freeTrialBox">
                      <div className="c-freeTrialBox__bclogo">
                        <Image alt="BigCommerce Logo" publicId="bc-logo-icon-light" />
                      </div>
                      <div className="c-freeTrialBox__content">
                        <h4 className="c-freeTrialBox__header u-h3">30 Day Free Trial <span className="o-smallprint">*</span></h4>
                        <p className="c-freeTrialBox__text">Would you like to try before you buy? </p>
                        <p>With Goose you can get 30 days instead of 15.....<em>we told you we had your back!</em> Let us know, we'll hook you up. No strings.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="c-clients l-clients__spacing">
            <div className="u-container u-container--heading c-clients__header-container">
              <h2 className="c-clients__heading l-clients__heading u-hero">
                Clients
              </h2>
              <p className="c-clients__intro l-homeServices__intro u-intro">A selection of our favourite BigCommerce Clients</p><br />
              {/* <span className="o-tgQuote">"Son, your ego is writing checks your body can’t cash!" - Stinger</span> */}
            </div>

            <div className="u-container u-container--m">
              <div className="c-clients__logos l-clients__logos">
                <Image alt="NZ Post Logo BigCommerce" publicId="client-logo-nzp" />
                <Image alt="The Comfort Group Logo BigCommerce" publicId="client-logo-tcg" />
                <Image alt="Mazda Logo BigCommerce" publicId="client-logo-mazda" />
                <Image alt="100% Magnness Benrow Logo BigCommerce" publicId="client-logo-magness" />
                <Image alt="Wild Poppies Logo BigCommerce" publicId="client-logo-wp" />
                <Image alt="Tile Space Logo BigCommerce" publicId="client-logo-tilespace" />
                <Image alt="Breastmates Logo BigCommerce" publicId="client-logo-breastmates" />
                <Image alt="kiwivelo Logo BigCommerce" publicId="client-logo-kv" />
              </div>
            </div>
            
          </section>
          <section className="c-homeWork">
            <div className="u-container u-container--heading">
              <h2 className="c-homeServices__heading l-homeServices__heading u-hero">
                Work
              </h2>
              <p className="c-homeServices__intro l-homeServices__intro u-intro">Our favourite client once told us we're too modest.
              </p><br />
              <span className="o-tgQuote">"Son, your ego is writing checks your body can’t cash!" - Stinger</span>
            </div>
            <div className="c-homeIntro__image l-homeIntro__image u-container u-container--m">
              <Image alt="BigCommerce Website NZ Post Collectables" publicId="nzp-collectables" />
              <div className="c-homeIntro__image__hashtag u-large">
                <a href="https://collectables.nzpost.co.nz/">collectables.nzpost.co.nz</a>
              </div>
              <div className="c-homeWork__results c-homeWork__results--centre">
                <h3 className="c-homeWork__results__header l-homeWork__results__header u-h1">Full Replatform</h3>
                <div className="c-homeWork__results__subheader l-homeWork__results__subheader u-h4">From Drupal CMS</div>
              </div>
              <div className="c-homeWork__results c-homeWork__results--centre">
                <h3 className="c-homeWork__results__header l-homeWork__results__header u-h1">Oracle ERP</h3>
                <div className="c-homeWork__results__subheader l-homeWork__results__subheader u-h4">Custom Integration</div>
              </div>
              <div className="c-homeWork__results c-homeWork__results--centre">
                <h3 className="c-homeWork__results__header l-homeWork__results__header u-h1">Personalised Stamps</h3>
                <div className="c-homeWork__results__subheader l-homeWork__results__subheader u-h4">Interactive Personalised Stamp App</div>
              </div>
            </div>
            <div className="c-homeIntro__image l-homeIntro__image u-container u-container--m">
              <Image alt="BigCommerce Website Magness Benrow" publicId="magness-v2" />
              <div className="c-homeIntro__image__hashtag u-large">
                <a href="https://magnessbenrow.co.nz">magnessbenrow.co.nz</a>
              </div>
              <div className="c-homeWork__results c-homeWork__results--centre">
                <h3 className="c-homeWork__results__header l-homeWork__results__header u-h1">187.04% Increase</h3>
                <div className="c-homeWork__results__subheader l-homeWork__results__subheader u-h4">In Conversion Rate</div>
              </div>
              <div className="c-homeWork__results c-homeWork__results--centre">
                <h3 className="c-homeWork__results__header l-homeWork__results__header u-h1">381% Increase</h3>
                <div className="c-homeWork__results__subheader l-homeWork__results__subheader u-h4">In Online Revenue</div>
              </div>
              <div className="c-homeWork__results c-homeWork__results--centre">
                <h3 className="c-homeWork__results__header l-homeWork__results__header u-h1">23.69% Increase</h3>
                <div className="c-homeWork__results__subheader l-homeWork__results__subheader u-h4">In Average Order Value</div>
              </div>
              <div className="c-homeWork__results c-homeWork__results--centre">
                <h3 className="c-homeWork__results__header l-homeWork__results__header u-h1 u-brand-red">See How We Did It</h3>
                <a href="/magness-bigcommerce">Click here to read the case study &#8594;</a>
              </div>
            </div>
            <div className="c-homeIntro__image l-homeIntro__image u-container u-container--m">
              <Image alt="BigCommerce Website Splash Australia" publicId="wp-tablet" />
              <div className="c-homeIntro__image__hashtag u-large">
                <a href="https://www.wildpoppies.co.nz/">wildpoppies.co.nz</a>
              </div>
              <div className="c-homeWork__results c-homeWork__results--centre">
                <h3 className="c-homeWork__results__header l-homeWork__results__header u-h1">60.80% Increase</h3>
                <div className="c-homeWork__results__subheader l-homeWork__results__subheader u-h4">In Online Revenue</div>
              </div>
              <div className="c-homeWork__results c-homeWork__results--centre">
                <h3 className="c-homeWork__results__header l-homeWork__results__header u-h1">82.45% Increase</h3>
                <div className="c-homeWork__results__subheader l-homeWork__results__subheader u-h4">In Unique purchases</div>
              </div>
              <div className="c-homeWork__results c-homeWork__results--centre">
                <h3 className="c-homeWork__results__header l-homeWork__results__header u-h1">Custom Checkout</h3>
                <div className="c-homeWork__results__subheader l-homeWork__results__subheader u-h4">Developed Specifically For Gifting</div>
              </div>
            </div>
          </section>
          <footer className="c-footer l-footer">
            <div className="c-footer__content l-footer__content">
              <div className="c-footer__header">
                <span>
                  <h5 className="u-epic"><Link onClick={this.handleContactModelClick} to="/">Talk To Me Goose</Link></h5>
                  <div className="c-footer__subheader">
                    <span className="o-tgQuote">- Maverick (a.k.a You)</span>
                  </div>
                </span>
              </div>
              <div className="c-footer__legal">
                <div className="c-footer__legal__copyright">
                  <span aria-label="copyright" role="img">&copy;</span> {new Date().getFullYear()} Goose Ltd - Ecommerce Growth Agency, <br />Auckland, New Zealand.
                </div>
                <div className="c-footer__legal__social">
                  <div className="o-socialIcons">
                    <div className="o-socialIcons__icon">
                      <a href={socialLinks.facebook}>
                        {IconFacebook}
                      </a>
                    </div>
                    <div className="o-socialIcons__icon">
                      <a href={socialLinks.instagram}>
                        {IconInsta}
                      </a>
                    </div>
                    <div className="o-socialIcons__icon">
                      <a href={socialLinks.youtube}>
                        {IconYoutube}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="c-footer__girtieTheGoose">
                <Image alt="Goose BigCommerce Web Design" publicId="goose" />
              </div>
            </div>
          </footer>

          <ContactModel toggleContactModel={this.handleContactModelClick} siteMeta={this.props.data.site.siteMetadata} ContactModelStatus={this.state.contactModelActive} />

        </CloudinaryContext>
      </div>
    );
  }
}

export default IndexRoute;

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
        subtitle
        copyright
        contactNumber
        contactEmail
        menu {
          label
          path
        }
        author {
          name
          email
          telegram
          twitter
          github
          rss
          vk
        }
        socialLinks {
          facebook
          instagram
          youtube
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.jsx